import { useTranslations } from 'next-intl';
import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './LocationPopup.module.scss';
import { MapPin } from 'lucide-react';
export interface LocationPopupInterface {
  show: boolean;
  handleClose?: () => void;
  getLocation?: () => void;
}
const LocationPopup: React.FC<LocationPopupInterface> = ({
  show,
  handleClose,
  getLocation
}) => {
  const t = useTranslations();
  return <Modal show={show} onHide={handleClose} centered dialogClassName={styles.dialog} contentClassName={styles.content} data-sentry-element="Modal" data-sentry-component="LocationPopup" data-sentry-source-file="LocationPopup.tsx">
            <Modal.Body className={styles.body} data-sentry-element="unknown" data-sentry-source-file="LocationPopup.tsx">
                <div className={styles.iconWrapper}>
                    <MapPin size={28} color="#000000" data-sentry-element="MapPin" data-sentry-source-file="LocationPopup.tsx" />
                </div>
                <h3 className={styles.title}>
                    {t('workspace-details.loc-title')}
                </h3>
                <p className={styles.subtitle}>
                    {t('workspace-details.loc-desc')}
                </p>
                <div className={styles.buttons}>
                    <button className={styles.allowBtn} onClick={getLocation}>
                        {t('workspace-details.allow')}
                    </button>
                    <button className={styles.cancelBtn} onClick={handleClose}>
                        {t('workspace-details.cancel')}
                    </button>
                </div>
            </Modal.Body>
        </Modal>;
};
export default LocationPopup;